module.exports = __webpack_public_path__ + "templates/outlets-catalog.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/outlets/templates/outlets-catalog.html
// module id = rGNw
// module chunks = 1